import React from "react";
import { Link } from "react-router-dom";
import { useFindInteractionByPractitionerQuery } from "generated/graphql";
import userVar from "vars/user";
import loggedInClinicVar from "vars/loggedInClinic";
import Empty from "components/Empty";
import { Progress, Stack } from "@chakra-ui/react";
import styled from "styled-components";

const CHWList = () => {
  const { data, error, loading } = useFindInteractionByPractitionerQuery({
    variables: {
      clinicId: loggedInClinicVar().id,
      practitionerId: userVar().id,
    },
    fetchPolicy: "network-only",
  });

  const Loading = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100vh - 400px);
    justify-content: center;
  `;

  if (loading) {
    return (
      <div>
        <Loading>
          <Stack>
            <Progress size="xs" isIndeterminate />
          </Stack>
        </Loading>
      </div>
    );
  }

  if (error) {
    return <Empty text={error.message} />;
  }

  if (data?.findInteractionByPractitioner?.length < 1) {
    return <Empty text="No Interaction found" />;
  }

  return (
    <div>
      {data?.findInteractionByPractitioner.map((interaction, i) => (
        <Link
          to={"/app/practitioner/activity/practitioner"}
          state={{ id: interaction.id }}
          key={i}
        >
          <div className="flex justify-between p-4">
            <p>
              {interaction?.chw?.firstName} {interaction?.chw?.lastName}
            </p>
            <p>{interaction?.prescriptionNumber}</p>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default CHWList;
